export function obterListaMdfeIndPag() {
  return (
    [
      { label: '0 - Pagamento à vista', value: 'AVISTA' },
      { label: '1 - Pagamento À prazo', value: 'APRAZO' },
    ]
  );
}
